export const EditMode = Object.freeze({
  MOVE: Symbol('move'),
  POINTER: Symbol('point'),
  SHAPEONLY: Symbol('shapeonly'),
});
